export default {
    login: '登入',
    logout: '登出',
    register: '新註冊',
    upload: '上傳',
    name: '姓名',
    email: '電子郵件地址',
    password: '密碼',
    passwordConfirmation: '密碼(確認用)',
    isCommunityManager: 'Community Manager',
    dashboard: '一覽表',
    offerLists: '上架產品列單',
    schedule: '時間表',
    accountEdit: '編輯帳戶資訊',
    edit: '編輯',
    detail: '詳情',
    fullname: '{{lastname}} {{firstname}}',
    quantity: '數量',
    quantityWithWeight: '數量 (重量)',
    confirmTitle: '確認',
    orderInformation: '預訂資訊',
    orderPrices: '價格變化歷史',
    invoices: '請款帳單',
    contact: '與我們聯繫',
    when: '時間',
    add_to_google_calendar: '新增至 Google 日曆',
    pages: {
        dashboard: {
            unpaidInvoices: {
                title: 'Unpaid invoices (10 unpaid invoices are displayed order by expired date)',
                totalUnpaidAmountAll: 'Unpaid invoices(all)',
                totalUnpaidAmountExpired: 'Unpaid invoices(expired)',
                more: 'view all',
            },
            typicaStockItemDelaySummaryPanel: {
                title: 'TYPICA selection residency status',
                chartTitleFromImported: 'imported to purchased',
                chartTitleFromPurchased: 'purchased to delivered',
                within1month: 'within 1month',
                within2month: 'within 2months',
                within3month: 'within 3months',
                within4month: 'within 4months',
                within5month: 'within 5months',
                over5month: 'over 5month',
                unitLabel: 'Weight(Kg)',
            },
            remainingWarehouseItems: {
                title: 'Pending status of pre-orders (Lump-sum payment after the initial delivery or Pay per delivery)',
                subTitles: {
                    byPeriod: 'By Period',
                    byCommunityManager: 'By Community manager',
                    byOffice: 'By Office',
                },
                more: 'view all',
                unitLabel: 'Weight(Kg)',
            },
        },
        offerUpload: {
            title: '上傳CSV',
            producer: 'Producer',
            download: '有一個CSV樣板',
            sampleDeliveryDateMemo: '預定上架開始日期必須在開始日期前14天',
            uploadMemo: '上傳完成後，稍後負責人會與您聯繫',
            suggestToCreateBankAccountText: "\u92B7\u552E\u6536\u5165\u9032\u884C\u6536\u6B3E\u9808\u6307\u5B9A\u9280\u884C\u5E33\u6236\u3002\n\u70BASales Contract\u6210\u7ACB\u6642\u7684\u5FC5\u8981\u9805\u76EE\uFF0C\u5EFA\u8B70\u63D0\u524D\u65BC\u4E0A\u50B3\u8A02\u55AE\u6642\u5B8C\u6210\u767B\u8A18\u3002",
        },
        offerList: {
            title: '{{country}} / {{name}} 的上架產品列表',
            createInvoices: '開立請款單',
            createInvoicesExplanation: "\u5C0D\u767B\u8A18\u9810\u7D04\u4FE1\u606F\u4E2D\u7684\u652F\u4ED8\u6642\u9593\u70BA\"1.\u6309\u7167\u751F\u7522\u8005\u8981\u6C42\u7684\u4E00\u6B21\u6027\u652F\u4ED8\"\uFF0C\u5C07\u4E00\u6B21\u6027\u958B\u7ACB\u767C\u7968\u3002\n\u4F46\u662F\uFF0C\u4E0D\u6703\u70BA\u5DF2\u958B\u7ACB\u767C\u7968\u7684\u9810\u8A02\u5275\u5EFA\u65B0\u767C\u7968\u3002\n\u5275\u5EFA\u7684\u767C\u7968\u7684 URL \u5C07\u901A\u904E\u96FB\u5B50\u90F5\u4EF6\u767C\u9001\u7D66\u6BCF\u500B\u70D8\u7119\u5EE0\u3002",
            sampleOrderStock: {
                quantity: '樣品庫存排序',
                lotVisibleLabel: 'Show/Hide Lot',
                show: 'Show',
                hide: 'Hide',
            },
            publishedCountriesTableTitle: '銷售國家',
            basicInformations: '基本資訊',
            publishedCountriesTable: '銷售國家',
            transportToWarehouseTable: '倉庫單位運輸信息',
            officeDetailTable: 'Office Information',
            offersTable: '上架產品',
            contracts: 'Contracts',
            sampleOrderPeriod: '樣品請求',
            orderPeriod: '接受預約',
            paymentPeriod: '付款時期',
            estimatedDeliveryPeriod: '預計抵達台灣的時間',
            paymentAfterDelivery: '交貨後事後付款',
            paymentPeriods: {
                reserved: '預訂時預先付款',
                exported: '出口時付款',
                imported: '抵達港口時付款',
                delivered: '交貨到店時',
            },
            installmentPaymentAfterImport: '於進倉後以分期方式付款',
            installmentPayment: '支付',
            estimatedPaymentDateFormat: '{{year}} {{month}} {{date}}',
            installmentPaymentsHelp: {
                title: '關於事後付款',
                body: "\u82E5\u60A8\u5728\u9810\u8A02\u6642\u9078\u64C7\u4E8B\u5F8C\u4ED8\u6B3E\uFF0C\u5247\u53EF\u4EE5\u5728\u4EA4\u8CA8\u5F8C\u4ED8\u6B3E\u3002\n\u53EF\u9078\u64C7\u9996\u6B21\u4EA4\u8CA8\u5F8C \"\u5168\u984D\u4E8B\u5F8C\u4ED8\u6B3E\"\uFF0C\u6216\u6BCF\u6B21\u5F9E\u5009\u5EAB\u51FA\u8CA8\u6642 \"\u5206\u6B21\u4E8B\u5F8C\u4ED8\u6B3E\"\u3002",
            },
            FreeOnBoardHelp: {
                title: '什麼是FOB？',
                body: "\u62B5\u9054\u751F\u7522\u570B\u6E2F\u53E3\u6642\u7684\u5496\u5561\u751F\u8C46\u50F9\u683C\uFF0C\u4E0D\u5305\u542B\u6D77\u904B\u904B\u8CBB\u548C\u9032\u53E3\u624B\u7E8C\u8CBB\u3002",
            },
            warehouseItemHelp: {
                title: '關於交貨請求',
                body: '於首次付款完成後進行商品配送。',
            },
            estimatedDeliveryPeriodFormat: '{{year}} {{month}} {{monthPart}}',
            okagesamaNoMori: 'OKAGESAMA',
            okagesamaNoMoriContributors: 'OKAGESAMA Contributors',
            okagesamaNoMoriTotalPrices: 'OKAGESAMA Total prices',
            okagesamaNoMoriStatuses: {
                title: 'OKAGESAMA Statuses',
                joined: 'Joined',
                paid: 'Joined(Paid)',
            },
        },
        editProfile: {
            title: '個人資料編輯',
            subTitle: '客戶資訊',
            questionnairesForRoaster: '烘豆師問卷調查',
            questionnairesForRoasterMemo: '* 以下內容之後也可更改',
            cannotChangeCountry: '* 請注意：一旦您註冊了所在國家即無法更改。',
        },
        editAccount: {
            title: '編輯帳戶資訊',
            currentEmail: '當前的電子郵件地址',
            warning: "\u66F4\u6539\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u5F8C\uFF0C\u60A8\u5C07\u88AB\u767B\u51FA\u3002\n\u78BA\u8A8D\u7528\u7684\u96FB\u5B50\u90F5\u4EF6\u5C07\u767C\u9001\u5230\u60A8\u7684\u65B0\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u3002\n\u9EDE\u64CA\u4FE1\u4E2D\u63D0\u4F9B\u7684\u93C8\u63A5\u4EE5\u5B8C\u6210\u66F4\u6539\u4E4B\u5F8C\uFF0C\u5373\u53EF\u4EE5\u4F7F\u7528\u65B0\u7684\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u767B\u5165\u3002",
        },
        exchangeRates: {
            title: '設定匯率',
            exchangeRateColumnTitle: 'USD/{{ currency }}換算',
        },
        roasterOfferLists: {
            sampleRequest: '樣品請求',
            order: '預訂',
            inactive: '結束公開',
        },
        roasterOrder: {
            title: '{{ listName }}的預訂',
            explanationSelectOffers: '・請檢查下列表中的庫存數量並選擇預訂數量。',
            explanationAuctionWithFobPriceUsdPerLb: '* 拍賣價以USD/Kg為基準。（1kg=2.20462lb）',
            explanationStockMightChange: '* 開啟視窗期間，庫存數量可能有變動或缺貨。敬請見諒。',
            order: '預訂',
            orderAmount: '預訂',
            totalFee: '總金額: {{ fee }}（含稅）',
            totalBags: '總袋數: {{ amount }} 包',
            totalOrderedBags: '已訂購數量: {{ amount }}袋',
            totalWeight: '總重量：{{ weight }}Kg',
            totalOrderedWeight: '已訂購重量：{{ weight }}Kg',
            totalOneTimeUpfrontOrderedBags: '預付款數量: {{ amount }}袋',
            typicaHandlingFee: 'TYPICA手續費: {{ percentage }}%',
            typicaHandlingFeeExplanationByBagCount: '少於 5包 {{ lessThan5Bags }} / 5包以上 {{ moreThan5Bags }} / 10包以上 {{ moreThan10Bags }} / 50包以上 {{ moreThan50Bags }}',
            typicaHandlingFeeExplanationByWeight: '未滿300Kg: {{ lessThan300Kg }} / 300Kg以上: {{ moreThan300Kg }} / 600Kg以上: {{ moreThan600Kg }} / 3,000Kg以上: {{ moreThan3000Kg }}',
            details: '明細',
            paymentAndDelivery: '付款方式/送貨地址',
            paymentMethodExplanation: "* \u4FE1\u7528\u5361\u7684\u4F7F\u7528\u984D\u5EA6\u4E0A\u9650\u53CA\u5206\u671F\u4ED8\u6B3E\u7684\u689D\u4EF6\u56E0\u4EBA\u800C\u7570\uFF0C\u8ACB\u5411\u60A8\u7684\u767C\u5361\u9280\u884C\u78BA\u8A8D\u3002\n        * \u6BCF\u4E00\u6B21\u7684\u8ACB\u6B3E\u91D1\u984D\u82E5\u6574\u6578\u90E8\u5206\u8D85\u904E8\u4F4D\u6578\uFF0C\u6709\u53EF\u80FD\u6703\u8ACB\u60A8\u4EE5\u9280\u884C\u532F\u6B3E\uFF0C\u656C\u8ACB\u898B\u8AD2\u3002",
            endOfMonth: '底前',
            oneTimeUpfrontExplanations: '- 付款期限為{{ paymentDate }}。請於下單後發行的請款單中確認詳細時程。',
            afterImportPaymentExplanations: "- \u4ED8\u6B3E\u671F\u9650\u70BA\u5496\u5561\u9032\u5009\u65E5\uFF08\u5927\u81F4\u6642\u7A0B\uFF1A{{ deliveryPeriod }}\uFF09\u8D77\u768414\u5929\u5167\u3002\n      - \u65BC\u4ED8\u6B3E\u5B8C\u6210\u5F8C\u9032\u884C\u5546\u54C1\u914D\u9001\u3002",
            fewTimesPaymentAfterImportExplanations: "- \u9996\u6B21\u4ED8\u6B3E\u671F\u9650\u70BA\u5496\u5561\u9032\u5009\u65E5\uFF08\u5927\u81F4\u6642\u7A0B\uFF1A{{ deliveryPeriod }}\uFF09\u8D77\u768414\u5929\u5167\u3002\n      - \u65BC\u9996\u6B21\u4ED8\u6B3E\u5B8C\u6210\u5F8C\u9032\u884C\u5546\u54C1\u914D\u9001\u3002\n      - \u7B2C2\u6B21\u4EE5\u5F8C\u7684\u4ED8\u6B3E\u6642\u7A0B\uFF0C\u70BA\u5496\u5561\u9032\u5009\u5F8C\u7684\u6B21\u6708\u6708\u5E95\u3002\u8ACB\u65BC\u6708\u521D\u767C\u884C\u7684\u8ACB\u6B3E\u55AE\u4E2D\u78BA\u8A8D\u8A73\u7D30\u6642\u7A0B\u3002",
            paymentTimingExplanation: '* 手續費會因不同付款時機而有所不同，詳情請見本畫面下方的價格估算。',
            oneTimeUpfrontRateConstraintByBagAmount: ' (僅限2袋以上訂單)',
            oneTimeUpfrontRateConstraintByWeight: ' (僅適用於預訂120Kg以上的客戶)',
            deliveryMethodExplanation: "* \u6211\u5011\u7684\u5009\u5EAB\u6536\u5230\u5546\u54C1\u5F8C\u7B2C\u4E8C\u500B\u6708\u7684\u7B2C\u4E00\u5929\u8D77\uFF0C\u5C07\u6536\u53D6\u6BCF\u6708\u6BCF 1 \u516C\u65A4 {{unitPrice}} \u7684\u5009\u5132\u8CBB\u3002",
            oneTimeUpfrontRateByBagAmount: '({{ percentage }} 折扣 * 僅限2袋以上訂單）',
            oneTimeUpfrontRateByWeight: ' | -{{ percentage }} 折扣',
            paymentTimingNegativeRate: ' | -{{ percentage }} 折扣',
            paymentTimingPositiveRate: ' | 付款手續費 {{ positive }}{{ percentage }}',
            addressExplanation: '* 請確認是否填寫完整住址，包含樓層、公寓名稱、房號等。',
            emailExplanation: '* 請確認是否填寫正確的電子郵件地址。',
            deliveryTimeEtcExplanation: '* 因物流繁忙，有可能無法指定配送時間，敬請原諒。',
            sample: '樣品',
            sampleOrder: '樣品請求',
            sampleOrdered: '已預訂',
            outOfSamples: '樣品無庫存',
            bidSubmitted: '完成下標',
            sampleOrderableCount: '可申請樣品數量',
            inputAddress: '輸入地址',
            simulateAndInputAddress: '價格詳情 / 輸入地址',
            simulation: '價格估算',
            sampleOrderCaption: '預訂以下LOT樣品',
            comment: '留言',
            commentHelp: '* 生產者和其他烘豆師也會看到此留言',
            translation: '您的意見可以翻譯成英文、西班牙文、日文、中文和韓文。',
            postComment: '留言',
            updateComment: '更新留言',
            deleteComment: '刪除留言',
            noComments: '暫無留言',
            cuppingScoreHelpText: '請填入SCA杯測表中所評價的分數',
            more: '查看更多',
            ordered: '已預訂',
            addInvoice: '建立請款單',
            preOrderExplanation: '預計可預訂期間：{{startedAt}} - {{endedAt}}。',
            countdownToOrder: '距離預約開始尚有 {{countdown}} ',
            confirmationOfBuyPartial: '不購買未達下標數量的Lot:{{lotNumber}}',
            auctionBadgeExplanation: "\u672CLot\u70BA\u975E\u516C\u958B\u7AF6\u6A19\uFF0C\u8ACB\u8F38\u5165\u6709\u610F\u8CFC\u8CB7\u7684\u50F9\u683C\u53CA\u6578\u91CF\u3002\n\u82E5\u4E0B\u6A19\u91D1\u984D\u9AD8\u65BC\u8D77\u6A19\u50F9\u683C\uFF0C\u5247\u6703\u4EE5\u62CD\u8CE3\u734E\u91D1\u7684\u65B9\u5F0F\u652F\u4ED8\u7D66\u751F\u7522\u8005\u3002\n\u7AF6\u6A19\u7D50\u679C\u6703\u5728\u4E4B\u5F8C\u4EE5\u96FB\u5B50\u90F5\u4EF6\u901A\u77E5\u3002\n\u6578\u5B57\u6A19\u8A18\u70BA\u73FE\u5728\u6709\u610F\u8CFC\u8CB7\u7684\u4E0B\u6A19\u4EF6\u6578\u3002",
            okagesamaNoMoriPrice: '* 參與計畫費用 {{ priceUsd }} (約 {{ price }})',
            okagesamaNoMoriPriceText: '(參與計畫費用可能會因匯率而變動。)',
            sampleStats: '烘豆師關注中',
            preorderStats: '烘豆師已購得',
        },
        ordersPage: {
            title: '預訂清單列表',
            detailsTitle: 'Pre-orders details',
        },
        sampleOrdersPage: {
            title: '請求樣品列表',
        },
        register: {
            accept: '同意條款',
        },
        orderedOfferLists: {
            title: '已被預定的上架產品列表',
        },
        sampleOrders: {
            title: '請求樣品列表',
            import: '匯入樣品請求清單',
        },
        sampleOrderedOfferLists: {
            title: '已被請求樣品的上架產品列表',
        },
        orderDetail: {
            orderItemsTableTitle: '預購Lot清單',
            bidsTableTitle: '下標Lot清單',
            changeStatus: 'Change status',
            preOrderRequestCreateOrEdit: '填寫或更改請求',
        },
        sampleOrderDetail: {
            requestedLotNumbers: '請求樣品Lot號碼',
        },
        invoice: {
            title: '預約訂單 {{orderIds}} 的請款單',
            billingTo: '帳單姓名',
            billingAddress: '帳單地址',
            transparencyInformation: {
                farm: '生產者',
                farmExplanation: '關於生產者信息請參閱<1>此處</1>了解。',
                mill: '處理廠',
                millExplanation: '從小型生產者購買的咖啡櫻桃和羊皮層在當地工廠進行精製處理。這包括國內運輸費用和原產國清關費用。',
                auctionBonus: '拍賣獎金',
                auctionBonusExplanation: '此金額為非公開拍賣的購買價格中超過起標金額的部分，會以拍賣獎金的方式支付給生產者。',
                shippingFee: '運輸費用',
                shippingFeeExplanation: '運費與進口費用（通關費、植物檢疫申請費用等）的總金額。',
                importTax: '進口營業稅',
                importTaxExplanation: '運費和商品價格總金額的{{ importTaxRate }}。',
                typica: 'TYPICA',
                typicaExplanationForExclusiveLot: 'TYPICA的報酬為（{{exclusiveTypicaHandlingRate}}）',
                typicaExplanationByBagCount: '這是TYPICA的利潤。（5包以下{{ lessThan5Bags }}；5包以上{{ moreThan5Bags }}；10包以上{{ moreThan10Bags }}；50包以上{{ moreThan50Bags }}）',
                typicaExplanationByWeight: 'TYPICA的報酬為。（未滿300Kg: {{ lessThan300Kg }}、300Kg以上: {{ moreThan300Kg }}、600Kg以上: {{ moreThan600Kg }}、3,000Kg以上: {{ moreThan3000Kg }}）',
                typicaExplanationForTypicaSelection: 'TYPICA的報酬為（40%）',
                typicaExplanationForTypicaSelectionByWeightV1: 'TYPICA的報酬為（未滿300Kg為: 40％，300Kg以上為: 35％，600Kg以上為: 30％，3,000Kg以上為: 25％）',
                typicaExplanationForTypicaSelectionByWeightV2: 'TYPICA的報酬為（未滿300Kg為: 35％，300Kg以上為: 25％，600Kg以上為: 20％，3,000Kg以上為: 15％）',
                consumptionTaxExplanation: '應稅成本和費用的{{ taxRate }}',
                vatReverseChargeExplanation: '適用VAT Reversed Charge(0%) 。',
                oldPriceVersionKgPriceNotice: '除了「事後付款手續費（免稅）, 事前付款折扣」和「服務費(免稅)」以外的kg單價',
                newPriceVersionKgPriceNotice: '未包含「按付款時間點的折扣或手續費」的每公斤單價。',
                specialTypicaDiscount: '折扣金額',
                specialTypicaDiscountExplanation: '此為適用於您訂購商品的折扣金額總額。',
                shippingFeeForJp: '國際運輸費用',
                shippingFeeExplanationForJp: '這是從裝貨港到卸貨港/機場的成本。',
                importTaxForJp: '進口・運送費用',
                importTaxExplanationForJp: '進口與運送費用包含從卸貨港到倉庫的派送與商品進口的相關的全部費用（包括通關費、植物檢疫申請費等）。',
                consumptionTaxExplanationForJp: '消費稅總計以生豆稅率8%，海外運輸費用和其他費用稅率為0%來計算',
                CoffeeCherryExplanation: '備註',
                negativeBreakdownCoffeeCherryExplanation: '由於咖啡果的價格上漲，導致{{producerName}}的負利潤。但為了建立與各位烘豆師長期的關係，他們選擇接受負利潤，保持往年一般水平的價格。',
            },
            paidStatus: '付款狀態',
            paidMessage: '{{paidDate}} 已付款',
            unpaidMessage: '請於 {{expiredDate}} 之前付款',
            changePaymentMethod: '變更付款方式',
            vatrcHelp: '個人頁面中輸入VAT號碼後，即可適用VAT Reversed Charge。',
        },
        adminUsers: {
            title: 'Users',
        },
        adminRoasters: {
            title: '烘豆師名單',
            typicaShareRatioCalculatedAt: 'TYPICA share ratio calculated at',
        },
        adminRoasterDetail: {
            title: 'Details for {{roaster}}',
        },
        adminProducers: {
            title: '生產者名單',
        },
        adminProducerDetail: {
            title: 'Details for {{producer}}',
        },
        countryInformations: {
            title: '原產國資訊',
        },
        roasterCountries: {
            title: '銷售國家',
        },
        adminOrder: {
            title: '代理預訂',
            selectRoaster: '請選擇烘豆師',
        },
        warehouses: {
            title: '倉庫管理',
        },
        warehouseItems: {
            title: '倉庫庫存',
            deliveryRequest: '請求送貨',
            addressInfo: '送貨地址',
            selectItems: '請選擇您希望出貨的Lot',
            explainationForQuantity: '數量以包裝單位表示，與預約時的訂購單位不同。',
            editDeliveryRequest: {
                caption: '您需要調整配送日程表嗎？',
                button: '編輯配送日程表',
            },
        },
        deliveryRequests: {
            title: '請求出貨清單',
            import: 'Input delivery charges in a batch',
        },
        deliveryRequestDetail: {
            title: '請求出貨詳情',
            basicInfo: '基本資訊',
            editForm: '編輯表格',
        },
        newDeliveryRequest: {
            title: 'Add New Delivery Request',
        },
        roasterWarehouseItems: {
            requestable: '可以出貨',
            delivered: '已交貨',
            delivering: '配送中',
        },
        offerListForum: {
            translateMessage: '翻譯訊息',
            changeTranslationLanguage: '更改翻譯語言',
            languages: {
                en: '英文',
                es: '西班牙文',
                ja: '日文',
                zh: '中文',
                ko: '韓文',
            },
        },
        monthlyClosing: {
            title: '月結單',
            createButton: '每月結帳處理',
        },
        balanceSheetEntry: {
            title: 'Balance Sheet Entries',
            advanceReceived: 'Advance Received',
        },
        offices: {
            title: '辦公室',
        },
        invoicePayment: {
            title: '支付請款單"{{invoiceTitle}}"的款項',
            suspendedMessage: "\u56E0\u652F\u4ED8\u7CFB\u7D71\u9032\u884C\u8B8A\u66F4\u4F5C\u696D\uFF0C\u76EE\u524D\u66AB\u505C\u4FE1\u7528\u5361\u4ED8\u6B3E\u529F\u80FD\uFF0C\u7169\u8ACB\u8010\u5FC3\u7B49\u5019\u81F3\u8B8A\u66F4\u4F5C\u696D\u5B8C\u6210\u3002\n      \u60A8\u53EF\u65BC\u652F\u4ED8\u7CFB\u7D71\u8B8A\u66F4\u4F5C\u696D\u5B8C\u6210\u5F8C\u518D\u9032\u884C\u4ED8\u6B3E\uFF0C\u82E5\u60A8\u5E0C\u671B\u76E1\u5FEB\u5B8C\u6210\u4ED8\u6B3E\u4F5C\u696D\uFF0C\u53EF\u9078\u64C7\u9280\u884C\u532F\u6B3E\u3002\n",
        },
        transportToWarehouse: {
            waterActivity: '水活性',
            moistureContent: '含水率',
        },
        adminAuction: {
            title: '{{offerListName}} / {{lotNumber}}的拍賣狀況',
            auctionClosed: '此拍賣已結束',
            auctionOpened: '此拍賣開放中',
            closeAuction: '結束拍賣',
            confirmation: 'This auction will be closed. Bids cannot be canceled after the auction is closed. Do you want to proceed?',
        },
        roasterBids: {
            title: '下標清單',
        },
        roasterAuction: {
            title: '{{offerListName}} / {{lotNumber}}的拍賣結果',
            bidQuantity: '交易數量',
            roasterAuctionResult: '您的交易結果',
            auctionResult: '整體交易結果',
        },
        adminCreateTypicaStockItems: {
            title: 'Create TYPICA Selection',
        },
        adminTypicaStockItems: {
            title: 'TYPICA Selection',
            helpQuantity: 'The total number of typica stock. This value is reflected when creating contracts such as Shipping instructions.',
            helpRemainingQuantity: 'Quantity - Ordered Quantity + Adjustment Quantity',
            helpAdjustmentQuantity: 'For adjusting the number of items in typica stock (e.g., to reduce the number of items in stock for sample requests)',
            helpSampleRemainingQuantity: 'Sample total quantity - Sample ordered quantity',
        },
        adminNewTypicaStockOrder: {
            title: 'Proxy pre-order from TYPICA Selection',
        },
        adminTypicaStockOrders: {
            title: 'TYPICA Selection pre-orders',
        },
        adminTypicaStockSampleOrders: {
            title: 'TYPICA Selection sample requests',
        },
        adminSalesContractAndAuctionBonusInvoice: {
            title: 'Sales Contract / Auction Bonus Invoice',
        },
        adminSalesContractBankAccount: {
            title: 'Producer Bank account information for salesContract',
        },
        producerBankAccounts: {
            title: '銀行帳戶資訊一覽',
            edit: '編輯銀行帳戶資訊',
            new: '建立銀行帳戶資訊',
        },
        producerOkagesamaNoMori: {
            title: 'OKAGESAMA',
        },
        adminRoasterSalesReward: {
            title: 'Roaster Sales Reward',
            netWeight: 'Weight',
            quantity: 'Quantity',
        },
        typicaSelection: {
            title: 'TYPICA精選',
            order: '查看預約詳情',
            sampleOrderPeriod: '隨時',
            orderPeriod: '隨時',
            paymentPeriod: '交貨後事後付款',
            estimatedDeliveryPeriod: '預約後1週左右',
            sampleOrder: '由此申請索取樣品',
            orderFormStepper: {
                order: '付款 & 帳單地址',
                deliveryRequest: '指定配送',
            },
            tooltip: {
                invalidDeliveryRequestGroup: {
                    oneTime: {
                        body1: '指定到貨日期為空白',
                        body2: '請指定到貨日期',
                    },
                    installment: {
                        body1: '仍有可配送的批次貨品',
                        body2: '請指定分批交貨的所有配送日期',
                    },
                },
                isNotWarehousing: {
                    body1: '貨品尚未入庫',
                    body2: '無法指定已入庫貨品以外的配送時間',
                },
                inValidDeliveryRequestItemsAndRequestDate: '請輸入配送數量或指定到貨日期',
            },
        },
        preOrderRequest: {
            title: '請求重複預訂列表',
            new: '重複預訂請求書',
            requestedOffer: 'Requested for repeat order Lot',
            lotNumberBlank: '從同一個訂購單內訂購',
        },
        roasterAddresses: {
            title: '通訊錄管理',
            billingAddresses: '帳單地址',
            deliveryAddresses: '收件地址',
        },
        cuppingComments: {
            title: '杯測品評摘要',
            commentedBy: '該貢獻來自',
            otherRoasters: '顯示其他 {{ count }} 位烘豆師',
        },
        createCuppingComment: {
            title: '撰寫評論',
        },
        deliveryRequestItemsAndRequestDateForm: {
            title: '指定配送',
            subheaders: {
                oneTime: '我們將在預計交貨的日期內一次整批交付。',
                installment: '在預計交貨的時間內，我們最多可分成三次交貨給您。',
                installmentCaption: '預計交貨時間：預約後約1週左右',
            },
            type: {
                oneTime: '一次交貨',
                installment: '分批交貨',
            },
            changeTimings: '變更為{{ timing }}',
            buttons: {
                new: '設定配送時間',
                add: '增加配送時間',
            },
            captions: {
                datePicker: {
                    fastestDelivery: '* 如果此欄位留空，則會盡快交付。',
                    main: {
                        deliveryDateExplanation: '* 您可以從今天起{{ startWeek }}後的日期開始，選擇在要求配送日起5個月內的期間內送達。',
                        startWeek1: '1週',
                        startWeek2: '2週',
                    },
                    sub: {
                        europe: '* 指定到貨日會因為地區的不同，造成實際配送時平均延遲約2週左右的情形，因此建議您提早指定到貨日期，不便之處，敬請見諒。',
                        etc: '* 指定到貨日會因為地區的不同，造成實際配送時延遲約1週左右的情形，因此建議您提早指定到貨日期，不便之處，敬請見諒。',
                    },
                },
                card: '* 為了保持新鮮狀態下送交到您手中，我們建議一次交貨。按照客戶的需求，我們也提供分批交貨，供您選擇。',
            },
            dialog: {
                title: '配送時間',
            },
        },
        adminWarehouseHoliday: {
            title: 'Warehouse holidays',
        },
        exportCsv: {
            title: 'CSV 下載',
        },
    },
    labels: {
        stock: '現貨庫存',
        stockUnit: '袋',
        lotRef: 'LOT',
        offerListSummary: '上架產品摘要',
        farmWithLink: '莊園',
        curatorName: 'Curator姓名',
        seller: '賣家',
        story: '故事',
        material: '相關資料',
        period: '上架期間',
        activeOfferLists: '發布中',
        preparingOfferLists: '準備發布',
        expiredOfferLists: '結束接單',
        noData: '沒有找到資料',
        paymentTimingOnAdmin: '付款時間',
        fullAddress: '地址',
        deliveryItems: '出貨清單（Lot: 數量）',
        all: '全部',
        inStock: '有現貨',
        forum: '公告欄',
        forumDisplayName: '公告欄顯示名稱',
        taxed: '不包含消費稅',
        paymentTimingHandlingFee: {
            negativeValue: '折扣',
            positiveValue: '付款手續費',
        },
        paid: '已付款',
        exported: '出口時',
        imported: '進口時',
        uploadContract: '請選擇欲上傳的契約書',
        uploadDocuments: '請選擇上傳資料',
        uploadBusinessNumberKrdocument: '請選擇圖像檔案',
        selectFoundingCurator: 'Input Founding curator name',
        pending: '未確定',
        newRoasterCampaignDiscount: '首次預購折扣',
        couponTarget: '優惠碼適用中',
        newRoasterCampaignUnderway: '首次購買優惠進行中!',
        agree: '我同意以上注意項目',
        memo: '筆記',
        tradeCountryUsages: '用法',
        tradeCountryProcessings: '精製方式',
        tradeCountryPriceRanges: '價格範圍',
        uneditableJoinedInOkagesamaNoMori: 'Cannot edit joined in OKAGESAMA with active offer lists',
        contributedToOkagesamaNoMori: '* 已加入OKAGESAMA計畫',
        default: '預設值',
        billingAddress: '帳單地址',
        deliveryAddress: '收件地址',
        deliveryRequestFormRequestDate: '指定到貨日',
        fastestDeliveryRequest: '最短時間內配送',
        deliveryRequestByDate: '指定日期配送',
        includesItems: 'Include invoice items',
        bulkDownloadMode: 'Bulk download mode',
        miscFeeForJp: '其他手續費 *2',
        taxNodeForJpCalculation: '*1為課稅8% / *2為課稅10% / *3為免稅',
    },
    buttons: {
        yes: '是',
        no: '否',
        create: '建立新內容',
        update: '更新',
        delete: '刪除',
        cancel: 'Cancel',
        apply: 'Apply',
        complete: '完畢',
        resetPassword: '重設密碼',
        changePassword: '更改密碼',
        reconfirmEmail: '重發確認郵件',
        chooseFile: '請選擇檔案',
        upload: '上傳',
        calculateFixed: '確定最終價格',
        cancelFixed: '取消最終價格確認',
        pay: '改成已付款',
        unpay: '取消已付款',
        downloadInvoice: '下載請款單',
        salesContractDownloadPdf: '下載 Sales Contract',
        auctionBonusInvoiceDownloadPdf: '下載 Auction Bonus Invoice',
        downloadCsv: '下載CSV',
        deliveryRequest: '請求出貨',
        processing: '處理中...',
        import: '匯入',
        addItem: 'Add Item',
        createContracts: '建立合約',
        changeStatusTo: '變更狀態為 {{status}}',
        setBankAccount: '設定銀行帳戶資訊',
        bankAccount: '銀行帳戶資訊',
        selectFoundingCurator: 'Select Founding curator',
        changeFoundingCurator: 'Change Founding curator',
        deleteFoundingCurator: 'Cancel Founding curator',
        salesReward: 'Sales Reward',
        manageCommunityManager: 'Manage Community Manager',
        stripePayment: '支付',
        taiwanApiResponse: {
            resend: 'Resend(Government Uniform Invoices)',
            update: 'Set success without resend(Government Uniform Invoices)',
            destroy: 'Remove success(Government Uniform Invoices)',
        },
        priceDetail: '查看預約詳情',
        setAsDefault: '設為預設值',
        selectAll: 'Select all',
        deselectAll: 'Deselect all',
        next: '下一步',
        updateNow: 'Update now',
        downloadOffersCsv: 'Download all lots',
    },
    links: {
        login: '由此處登入',
        register: '由此處註冊',
        resetPassword: '忘記密碼',
        reconfirmEmail: '重新發送確認電子郵件',
        back: '返回',
        payFromHere: '由此處付款',
        story: '故事',
        movie: '影片',
        privacy_policy: '隱私政策',
        specified_commercial_transactions_law: '關於特定商業交易法的說明',
        tos: '服務條款',
        trackingUrl: '運送狀況',
        cookiePolicy: 'Cookie策略',
    },
    messages: {
        registerSuccess: '我們已向 {{email}} 發送電子郵件以確認您的電子郵件地址的有效性。請通過電子郵件中提供的鏈接完成註冊。',
        confirmationSuccess: '已經確認了電子郵件地址的驗證。請使用設定的電子郵件地址和密碼登入。',
        unlockSuccess: '您已將帳號解鎖。',
        resetPasswordSuccess: '已重設密碼，請確認電子郵件。',
        accountUpdateSuccess: '帳戶資訊已被編輯。請確認電子郵件。',
        changePasswordSuccess: '已更改密碼。',
        reconfirmEmailSuccess: '已重新發送確認郵件至您的信箱。',
        invalidEmail: '請輸入正確的電子郵件地址',
        invalidPostalCode: '郵遞區號請輸入數字',
        loginSuccess: '已登入',
        logoutSuccess: '已登出',
        uploadSuccess: '已變更CSV上傳',
        createSuccess: '建立',
        updateSuccess: '已更新',
        deleteSuccess: '已刪除',
        updateFailure: '失敗',
        deleteConfirm: '確定要刪除嗎？',
        rejectConfirm: 'This will cancel the bid for failing the screening. Are you really sure?',
        bidCancelConfirm: '您確定要取消下標嗎？',
        orderSuccess: '訂購成功',
        typicaStockOrderSuccess: '您已完成訂購。已入倉庫的商品可從倉庫庫存一覽中申請出貨。',
        sampleOrderSuccess: '已預訂樣品',
        deliveryRequestSuccess: '準備出貨中。完成出貨準備後，會再次通知您',
        cancelConfirm: '取消後無法復原，確定要取消嗎？',
        calculateFixed: "\u6279\u51C6\u70D8\u8C46\u5E2B\u7684\u9810\u8A02\u7533\u8ACB\u4E26\u6210\u7ACB\u8CB7\u8CE3\u5408\u7D04\u3002\n\u8ACB\u78BA\u8A8D\u91D1\u984D\u662F\u5426\u6B63\u78BA\u3002\n\u8ACB\u78BA\u8A8D\u662F\u5426\u78BA\u5B9A\u6700\u7D42\u50F9\u683C\uFF1F",
        calculateFixedSuccess: '已確認預訂最終總金額',
        cancelFixed: "\u53D6\u6D88\u8207\u70D8\u8C46\u5E2B\u7684\u8CB7\u8CE3\u5408\u7D04\u3002\n\u53D6\u6D88\u5408\u7D04\u6703\u5B58\u5728\u98A8\u96AA\u3002\n\u4F60\u771F\u7684\u8981\u53D6\u6D88\u55CE\uFF1F",
        cancelFixedSuccess: '已取消確認最終價格',
        commentSuccess: '已留言',
        deleteCommentConfirmTitle: '刪除留言',
        deleteCommentConfirmBody: '確定刪除留言嗎？',
        changePasswordTokenError: '密碼重設已過期。請再次重設。',
        deleteInvoiceConfirmTitle: '刪除請款單',
        deleteInvoiceConfirmBody: '確定要刪除請款單嗎？',
        deleteInvoiceItemConfirmTitle: '刪除請款明細',
        deleteInvoiceItemConfirmBody: '確定要刪除請款明細嗎？',
        sendInvoiceMailConfirmTitle: '電子郵件通知',
        sendInvoiceMailConfirmBody: '是否以電子郵件通知烘豆師已發行請款單？',
        sentSuccess: '已發送電子郵件。',
        payConfirmTitle: '已確認付款',
        payConfirmBody: '請確認是否改為已確認付款。',
        unpayConfirmTitle: '取消已確認付款',
        unpayConfirmBody: '確定取消已確認付款？',
        nRowsSelected: '已選擇 {0} 件',
        noDeliveryRequest: '沒有出貨請求',
        invalidOrderCombination: '樣品請求和預訂不能同時進行。',
        orderExplanationTitle: '預購注意事項',
        sampleOrderExplanationTitle: '關於索取樣品的注意事項',
        auctionOrderExplanationTitle: '拍賣預購的注意事項',
        sampleOrderExplanationBody: "\u56E0\u6578\u91CF\u6709\u9650\uFF0C\u6A23\u54C1\u50C5\u9650\u6709\u610F\u8CFC\u8CB7\u8005\u7D22\u53D6\u3002\n\u6B64\u5916\u6211\u5011\u5C07\u5728\u5168\u570B\u5404\u5730\u8209\u8FA6\u5168\u6279\u6B21\u7684\u793E\u7FA4\u676F\u6E2C\u3002\n\u8A73\u60C5\u8ACB\u53C3\u898B\u96FB\u5B50\u90F5\u4EF6\u7684\u516C\u544A\u3002",
        deliveryTimeExplanationTitle: '關於運送的注意事項',
        deliveryTimeExplanationForUsBody: "* There are additional costs associated with last-mile delivery from RPM warehouse in NJ via Accurate Transport.\n    * Please click <0>here</0> for delivery charges and <1>here</1> for delivery time.\n    * Arranging your own local shipping company or picking up at the warehouse are also possible. If so, please indicate this in the Note.\n    * Delivery could be delayed by logistical problems.\n    * Please feel free to ask if you have any questions.",
        deliveryTimeExplanationBody: "* \u570B\u5167\u904B\u8CBB\u53E6\u8A08\u3002\n* \u56E0\u904B\u9001\u8DEF\u7DDA\u7B49\u539F\u56E0\uFF0C\u6709\u53EF\u80FD\u9020\u6210\u9810\u5B9A\u4EA4\u8CA8\u65E5\u7684\u5EF6\u9072\u3002\n* \u82E5\u6709\u4EFB\u4F55\u554F\u984C\uFF0C\u656C\u8ACB\u4F86\u4FE1\u8A62\u554F\u3002\n* \u9031\u672B\u53CA\u570B\u5B9A\u5047\u65E5\u7121\u6CD5\u9032\u884C\u6536\u8CA8\u6216\u904B\u9001\u3002\n* \u6536\u5230\u7533\u8ACB\u5F8C\uFF0C\u6703\u65BC 3 \u500B\u5DE5\u4F5C\u5929\u5F8C\u958B\u59CB\u904B\u9001\u3002",
        orderExplanationForUsBody: "* Please refer to <0>our terms and conditions</0> before proceeding with pre-orders.\n\n    * Pre-order pricing is ex-warehouse.\n    There are additional costs associated with last-mile delivery from RPM warehouse in NJ via Accurate Transport.\n    Please see <1>this file</1> for delivery costs by destination in NYC area.\n    Kindly note that shipping fees for delivery outside of New York, New Jersey, Maryland, Delaware, and Washington D.C. will be confirmed once we obtain a quote from the delivery company.\n\n    * An estimated delivery date may be delayed due to circumstances in production areas or distribution channels.\n\n    * The quality of the product shall be the same as the sample.\n\n    * As green coffee production is strongly affected by the situation and climate of production areas, conditions may be subject to change. Please note that this pre-order does not immediately guarantee the conclusion of your order. We will send you confirmation of your order after the end of a pre-order period.",
        orderExplanationBody: "* \u9810\u8CFC\u524D\u8ACB\u52D9\u5FC5\u8A73\u8B80<0>\u4F7F\u7528\u689D\u6B3E</0>\u3002\n\n* \u570B\u5167\u904B\u8CBB\u53E6\u8A08\u3002\n\n* \u5230\u8CA8\u65E5\u6709\u53EF\u80FD\u4F9D\u7522\u5730\u6216\u904B\u9001\u72C0\u6CC1\u800C\u5EF6\u9072\u3002\n\n* \u7522\u54C1\u54C1\u8CEA\u4EE5\u6A23\u54C1\u70BA\u6E96\u3002\n\n* \u5496\u5561\u751F\u8C46\u7684\u751F\u7522\u6703\u53D7\u5230\u7522\u5730\u72C0\u6CC1\u53CA\u6C23\u5019\u5F37\u70C8\u5F71\u97FF\u800C\u7522\u751F\u689D\u4EF6\u8B8A\u52D5\u3002\u672C\u9810\u8CFC\u4E26\u4E0D\u4FDD\u8B49\u8A02\u55AE\u6210\u7ACB\uFF0C\u9810\u8CFC\u8A02\u55AE\u6210\u7ACB\u6703\u5728\u9810\u8CFC\u671F\u9593\u7D50\u675F\u5F8C\u53E6\u884C\u901A\u77E5\u3002\n    ",
        createdInvoices: '已建立 {{count}} 件請款單',
        orderNotStarted: '預約開始時間為  {{ startedAt }}',
        createContractsTitle: 'Preparation of contract documents',
        createContractsBody: "This will create the templates for the contract documents.\nPlease make sure that you have not forgotten to create TYPICA Stock.\nDo you want to proceed?",
        changeContractStatusToPublished: 'Set to Published. If you make it issued, it will be published to the producer and you will be notified by email. Are you sure?',
        changeContractStatusToDraft: 'Set to draft. Are you sure?',
        salesContractDownloadExplanationTitle: '下載SalesContract時的注意事項',
        salesContractDownloadExplanationBody: "\u4E0B\u8F09SalesContract\u524D\uFF0C\u5FC5\u9808\u5148\u8A2D\u5B9A\u9280\u884C\u5E33\u6236\u8CC7\u8A0A\u3002\n\u8ACB\u9078\u64C7\u9280\u884C\u5E33\u6236\u8CC7\u8A0A\uFF0C\u82E5\u6709\u9700\u6CE8\u610F\u4E8B\u9805\u4E5F\u8ACB\u4E00\u4F75\u9644\u4E0A\u3002",
        addBankAccountInformation: "\u4E0B\u8F09SalesContract\u9808\u5148\u8A2D\u5B9A\u9280\u884C\u5E33\u6236\u8CC7\u8A0A\u3002\n\u8ACB\u81F3\u4EE5\u4E0B\u9023\u7D50\u8A2D\u5B9A\u9280\u884C\u5E33\u6236\u8CC7\u8A0A\u3002",
        createBankAccount: '已完成銀行帳戶登記',
        orderedOfferNotExist: '沒有預訂產品',
        stripeConfirmBody: '最終確認：進行支付嗎？',
        updateSuccessInvoicePaid: '您已成功付款。請款單狀態反映已付款可能需要一點時間，煩請見諒。',
        deliverySampleWarningMessage: '樣品將在入庫後順序出貨。入庫預計為{{ approvalDate }}',
        deliverySampleWarningConfirmationMessage: '以下樣品將在入庫後順序出貨。',
        contactToTypicaMessage: '若您有任何問題，麻煩透過下列電子郵件信箱與我們聯繫',
        contactToTypicaMailSubject: 'TYPICA Direct Trade Platform',
        selectColumns: 'Select Columns',
        exchangeRateMoreThanHighestRateOnPrevMonth: 'The exchange rate exceeds the highest rate ({{ rate }}) for the previous month. Are you sure?',
        exchangeRateLessThanLowestRateOnPrevMonth: 'The exchange rate is below the lowest rate ({{ rate }}) of the previous month. Are you sure?',
        updateRequired: 'New version {{ version }} found! Reload after 5 seconds...',
        newPlatformRegisterNotice: '我們已於 2024 年 8 月 6 日起遷移到新平台。如果您想註冊為新用戶，請透過<0>點擊此處</0>進行註冊。',
        newPlatformNotice: '我們將從 2024 年 8 月 6 日起，將資料轉移到新平台。瀏覽網站，請按<0>這裡</0>。',
        newPlatformSampleNotice: '新平台的樣品索取清單資料在<0>這裡</0>。',
        newPlatformOrderNotice: '新平台的預購清單在<0>這裡</0>。',
        newPlatformInvoiceNotice: '新平台的發票在<0>這裡<0/>。',
        newPlatformProfileNotice: "\u6B64\u8655\u66F4\u65B0\u8CC7\u8A0A\u4E0D\u6703\u81EA\u52D5\u8F49\u79FB\u5230\u65B0\u5E73\u53F0\u3002\n\u5C0D\u65BC\u9020\u6210\u60A8\u7684\u4E0D\u4FBF\uFF0C\u6211\u5011\u6DF1\u8868\u6B49\u610F\uFF0C\u8ACB\u81F3<0>\u65B0\u5E73\u53F0\u66F4\u65B0\u8CC7\u8A0A</0>\u3002",
    },
    errors: {
        isRequired: '請輸入{{ field }}',
        invalid: '{{ field }} 是無效值',
        positive: '請於{{ field }}輸入1以上的數值',
        integer: '請於{{ field }}輸入半角數字',
        decimal: '請於{{ field }}輸入半角數字與.(小數點）',
        alphanumeric: '請於{{ field }}輸入半角英文字母與數字',
        invalidPostalCode: 'Postal code must be alphanumeric 7 characters',
        invalidCity: 'City must be 12 double-byte characters or less',
        invalidAddress: '{{ field }} must be full-width {{ fullWidthMaxLength }} character/half-width {{ halfWidthMaxLength }} character or less',
        purchaseLimitError: '此Lot的購買限額為{{ limit }}',
        lowestBidFobPriceError: '您輸入的價格低於起標價格',
        totalFeeUpperLimitError: '超過信用卡付款上限。請您改以銀行匯款，或調整總金額至8位數以下。',
        noStock: '缺貨',
        sameTypicaStockItemExists: 'Same Lot and warehouse combination already exists',
        mustOverOfferMinOrderWeight: '請輸入大於Lot的訂購單位 {{ minOrder }}的重量',
        notSelectableLessThanOrdersTotalWeight120Kg: '120公斤以上的訂購可以進行選擇',
        zeroDeliveryFeeMessage: 'This lot should be processed with a delivery fee of 0',
        mustBeZeroDeliveryFee: 'This lot only accepts a delivery fee of 0',
        hasTargetWarehouseItemMessage: 'Note: This contains items that should have a delivery fee of 0',
    },
    options: {
        isExists: {
            '1': '有',
            '0': '無',
        },
        isQGrader: {
            '1': '擁有Q Grader資格',
            '0': '無Q Grader資格',
        },
    },
    stripePayment: {
        failure: '支付失敗。請再次從頭開始。',
        afterStatusSucceeded: '您的付款已完成。反映已付款可能需要一點時間，煩請見諒。',
    },
    tradeCountryUsages: {
        filter: 'Filter',
        espresso: 'Espresso',
        omniroast: 'Omniroast',
        blend_component: 'Blend component',
    },
    tradeCountryProcessings: {
        washed: 'Washed',
        honey: 'Honey',
        natural: 'Natural',
        washed_anaerobic: 'Washed Anaerobic',
        natural_anaerobic: 'Natural Anaerobic',
        experimental: 'Experimental',
    },
    tradeCountryPriceRanges: {
        '5_to_10_dollars': '$5~10',
        '10_to_15_dollars': '$10~15',
        '15_to_20_dollars': '$15~20',
        '20_to_30_dollars': '$20~30',
        '30_dollars_or_more': '$30~',
    },
    admin: {
        exportCsv: {
            title: 'CSV 下載',
            labels: {
                officeLabel: '據點',
                fromDateLabel: '開始日期',
                toDateLabel: '結束日期',
                downloadButton: '下載',
            },
            errors: {
                invalidDateFormat: '請輸入正確的日期格式',
                toDateBeforeFromDate: '結束日期不能早於開始日期',
            },
            taxReturns: {
                title: '稅務申報 CSV',
            },
            accountingData: {
                title: '會計資料CSV',
            },
            deliveryFee: {
                title: '運費CSV',
            },
            warehouseFee: {
                title: '倉庫使用費CSV',
            },
            offerList: {
                title: '報價單列表CSV',
            },
            pendingWarehouseFee: {
                title: '未開立發票倉庫費用CSV',
            },
        },
    },
};
